// Field schemas for the admin content manager.
// types: text, textarea, number, boolean, select, image, json
export const SCHEMAS = {
  insights: {
    label: "Insights / Articles",
    fields: [
      { name: "title", label: "Title", type: "text" },
      { name: "slug", label: "URL Slug", type: "text" },
      { name: "category", label: "Category", type: "text" },
      { name: "author", label: "Author", type: "text" },
      { name: "reading_time", label: "Reading Time", type: "text" },
      { name: "excerpt", label: "Excerpt", type: "textarea" },
      { name: "cover_image", label: "Cover Image", type: "image" },
      { name: "body", label: "Body", type: "textarea", big: true },
      { name: "seo_title", label: "SEO Title", type: "text" },
      { name: "seo_description", label: "SEO Description", type: "textarea" },
    ],
  },
  publications: {
    label: "Publications",
    fields: [
      { name: "title", label: "Title", type: "textarea" },
      { name: "authors", label: "Authors", type: "textarea" },
      { name: "journal", label: "Journal", type: "text" },
      { name: "year", label: "Year", type: "text" },
      { name: "doi", label: "DOI", type: "text" },
      { name: "url", label: "URL (PubMed/DOI)", type: "text" },
      { name: "publication_type", label: "Publication Type", type: "text" },
      { name: "cancer_type", label: "Cancer Type", type: "text" },
      { name: "research_area", label: "Research Area", type: "text" },
      { name: "abstract", label: "Abstract", type: "textarea", big: true },
    ],
  },
  clinical_expertise: {
    label: "Clinical Expertise",
    fields: [
      { name: "title", label: "Title", type: "text" },
      { name: "slug", label: "Slug", type: "text" },
      { name: "summary", label: "Summary", type: "textarea" },
      { name: "overview", label: "Overview", type: "textarea", big: true },
      { name: "what_is", label: "What it is", type: "textarea" },
      { name: "diagnosis", label: "Diagnosis", type: "textarea" },
      { name: "treatment", label: "Treatment", type: "textarea" },
      { name: "when_to_seek", label: "When to Seek Advice", type: "textarea" },
      { name: "faqs", label: "FAQs [{q,a}]", type: "json" },
    ],
  },
  awards: {
    label: "Awards & Recognition",
    fields: [
      { name: "category", label: "Category", type: "text" },
      { name: "title", label: "Title", type: "text" },
      { name: "year", label: "Year", type: "text" },
      { name: "description", label: "Description", type: "textarea" },
    ],
  },
  timeline: {
    label: "Professional Timeline",
    fields: [
      { name: "year", label: "Year / Period", type: "text" },
      { name: "title", label: "Title", type: "text" },
      { name: "org", label: "Organization", type: "text" },
      { name: "location", label: "Location", type: "text" },
      { name: "description", label: "Description", type: "textarea" },
    ],
  },
  memberships: {
    label: "Memberships & Boards",
    fields: [
      { name: "category", label: "Category", type: "text" },
      { name: "name", label: "Name", type: "text" },
      { name: "period", label: "Period", type: "text" },
    ],
  },
  research_themes: {
    label: "Research Themes",
    fields: [{ name: "name", label: "Name", type: "text" }, { name: "slug", label: "Slug", type: "text" }],
  },
  media_coverage: {
    label: "Media Coverage",
    fields: [
      { name: "title", label: "Headline", type: "text" },
      { name: "media_type", label: "Media Type", type: "select", options: ["Television", "Newspapers", "Magazines", "Online Publications", "Interviews", "Podcasts", "Press Features", "Conference Coverage", "YouTube"] },
      { name: "publication", label: "Publication", type: "text" },
      { name: "date", label: "Date", type: "text" },
      { name: "description", label: "Description", type: "textarea" },
      { name: "url", label: "External URL", type: "text" },
      { name: "image", label: "Image", type: "image" },
    ],
  },
  events: {
    label: "Events",
    fields: [
      { name: "title", label: "Title", type: "text" },
      { name: "event_type", label: "Type", type: "select", options: ["Conference", "Lecture", "Camp", "Webinar", "Keynote", "Panel", "Meeting"] },
      { name: "date", label: "Date", type: "text" },
      { name: "location", label: "Location", type: "text" },
      { name: "description", label: "Description", type: "textarea" },
    ],
  },
  education_resources: {
    label: "Education Resources",
    fields: [
      { name: "title", label: "Title", type: "text" },
      { name: "resource_type", label: "Type", type: "select", options: ["Lectures", "Videos", "Clinical Insights", "Journal Club", "Reading Lists", "Educational Articles", "Conference Talks", "Webinars", "Research Resources", "Career Guidance", "Mentorship", "Editorial"] },
      { name: "category", label: "Category", type: "text" },
      { name: "description", label: "Description", type: "textarea" },
      { name: "url", label: "URL", type: "text" },
    ],
  },
  gallery_albums: {
    label: "Gallery Albums",
    fields: [
      { name: "title", label: "Title", type: "text" },
      { name: "slug", label: "Slug", type: "text" },
      { name: "category", label: "Category", type: "text" },
      { name: "cover_image", label: "Cover Image", type: "image" },
      { name: "description", label: "Description", type: "textarea" },
    ],
  },
  gallery_images: {
    label: "Gallery Photos",
    fields: [
      { name: "album_id", label: "Album", type: "reference", refCollection: "gallery_albums" },
      { name: "image", label: "Photo", type: "image" },
      { name: "caption", label: "Caption", type: "text" },
      { name: "date", label: "Date", type: "text" },
      { name: "location", label: "Location", type: "text" },
    ],
  },
  videos: {
    label: "Featured Videos",
    fields: [
      { name: "title", label: "Title", type: "text" },
      { name: "youtube_id", label: "YouTube URL or Video ID (paste a link)", type: "text" },
      { name: "video_url", label: "Or upload a video file (mp4/mov)", type: "file", accept: "video/*" },
      { name: "description", label: "Description", type: "textarea" },
    ],
  },
  fundraising: {
    label: "Fundraising Campaigns",
    fields: [
      { name: "title", label: "Title", type: "text" },
      { name: "goal", label: "Goal", type: "text" },
      { name: "raised", label: "Raised", type: "text" },
      { name: "description", label: "Description", type: "textarea" },
      { name: "image", label: "Image", type: "image" },
    ],
  },
  impact_stats: {
    label: "Impact Statistics",
    fields: [
      { name: "label", label: "Label", type: "text" },
      { name: "value", label: "Value", type: "text" },
      { name: "note", label: "Note", type: "text" },
    ],
  },
  impact_stories: {
    label: "Impact Stories",
    fields: [
      { name: "title", label: "Title", type: "text" },
      { name: "category", label: "Category", type: "text" },
      { name: "location", label: "Location", type: "text" },
      { name: "date", label: "Date", type: "text" },
      { name: "summary", label: "Summary", type: "textarea" },
      { name: "body", label: "Body", type: "textarea", big: true },
      { name: "image", label: "Image", type: "image" },
    ],
  },
  camps: {
    label: "Village Camps",
    fields: [
      { name: "title", label: "Camp Name", type: "text" },
      { name: "date", label: "Date", type: "text" },
      { name: "location", label: "Location", type: "text" },
      { name: "description", label: "Description", type: "textarea" },
      { name: "image", label: "Image", type: "image" },
    ],
  },
  ngo_content: {
    label: "NICCI / NGO Content",
    fields: [
      { name: "title", label: "Title", type: "text" },
      { name: "category", label: "Type", type: "select", options: ["Programme", "Current Project", "Success Story", "News & Update", "Annual Report", "Volunteer Opportunity"] },
      { name: "date", label: "Date", type: "text" },
      { name: "description", label: "Description", type: "textarea", big: true },
      { name: "image", label: "Image", type: "image" },
      { name: "url", label: "Link (optional)", type: "text" },
    ],
  },
  awareness_drives: {
    label: "Awareness Drives",
    fields: [
      { name: "title", label: "Title", type: "text" },
      { name: "category", label: "Type", type: "select", options: ["Pink October", "Walkathon", "Public Talk", "School Programme", "Women's Health", "Survivor Event", "Screening Drive"] },
      { name: "date", label: "Date", type: "text" },
      { name: "location", label: "Location", type: "text" },
      { name: "description", label: "Description", type: "textarea" },
      { name: "image", label: "Image", type: "image" },
    ],
  },
  volunteers: {
    label: "Volunteers",
    fields: [
      { name: "name", label: "Name", type: "text" },
      { name: "role", label: "Role", type: "text" },
      { name: "location", label: "Location", type: "text" },
      { name: "description", label: "Description", type: "textarea" },
    ],
  },
  partnerships: {
    label: "Partnerships",
    fields: [
      { name: "name", label: "Partner Name", type: "text" },
      { name: "type", label: "Type", type: "text" },
      { name: "description", label: "Description", type: "textarea" },
    ],
  },
  site_content: {
    label: "Site Content (Pages)",
    singletonKey: "key",
    fields: [
      { name: "key", label: "Key", type: "text", readonly: true },
      { name: "value", label: "Value (JSON)", type: "json", big: true },
    ],
  },
};

export const GROUPS = [
  { title: "Content", items: ["insights", "publications", "clinical_expertise", "awards", "timeline", "memberships", "research_themes", "media_coverage", "events", "education_resources", "gallery_albums", "gallery_images", "videos"] },
  { title: "Impact", items: ["impact_stats", "impact_stories", "camps", "awareness_drives", "ngo_content", "fundraising", "volunteers", "partnerships"] },
  { title: "Pages", items: ["site_content"] },
];
